var productReviewsCarousel = {
  init: function() {
    $('.js-product-reviews-carousel').each(function (index, element) {
      var $carousel = $(element);
      var slideCount = $carousel.find('.gallery-cell').length;
      
      if (slideCount <= 1) {
        return;
      }
      
      if ($carousel.hasClass('flickity-enabled')) {
        $carousel.flickity('destroy');
      }

      var flickityOptions = {
        cellAlign: 'center',
        draggable: true,
        freeScroll: false,
        imagesLoaded: true,
        pageDots: false,
        prevNextButtons: false,
        wrapAround: true,
        contain: true,
        cellSelector: '.gallery-cell',
        adaptiveHeight: false,
        setGallerySize: true,
        resize: true
      };

      $carousel.flickity(flickityOptions);
      
      setTimeout(function() {
        if ($carousel.hasClass('flickity-enabled')) {
          $carousel.flickity('resize');
        }
      }, 100)
      
      $carousel.addClass('product-reviews-carousel-initialized');
      $carousel.closest('.product-reviews-carousel').addClass('initialized');

      var $section = $carousel.closest('.product-reviews-carousel');
      var $prevButton = $section.find('.product-reviews-carousel__nav-button--prev');
      var $nextButton = $section.find('.product-reviews-carousel__nav-button--next');
      var $navContainer = $section.find('.product-reviews-carousel__nav');

      if ($navContainer.length === 0) {
        var $header = $section.find('.product-reviews-carousel__header');
        if ($header.length > 0) {
          $navContainer = $('<div class="product-reviews-carousel__nav"></div>');
          $prevButton = $('<button class="product-reviews-carousel__nav-button product-reviews-carousel__nav-button--prev" aria-label="Previous review">'</button>');
          $nextButton = $('<button class="product-reviews-carousel__nav-button product-reviews-carousel__nav-button--next" aria-label="Next review">'</button>');
          
          $navContainer.append($prevButton).append($nextButton);
          $header.append($navContainer);
        }
      }

      $prevButton.off('click.productReviewsCarousel').on('click.productReviewsCarousel', function(e) {
        e.preventDefault();
        $carousel.flickity('previous');
      });

      $nextButton.off('click.productReviewsCarousel').on('click.productReviewsCarousel', function(e) {
        e.preventDefault();
        $carousel.flickity('next');
      });

      function updateButtonStates() {
        var flkty = $carousel.data('flickity');
        if (!flkty) {
          return;
        }

        var needsNavigation = slideCount > 1;
        $navContainer.toggle(needsNavigation);
      }

      // Remove aria-selected attributes that Flickity adds (invalid for role="group")
      function removeAriaSelected() {
        $carousel.find('.gallery-cell').removeAttr('aria-selected');
      }

      $carousel.off('select.productReviewsCarousel settle.productReviewsCarousel change.productReviewsCarousel')
              .on('select.productReviewsCarousel', function() {
                removeAriaSelected();
                updateButtonStates();
              })
              .on('settle.productReviewsCarousel', function() {
                removeAriaSelected();
                updateButtonStates();
              })
              .on('change.productReviewsCarousel', function() {
                removeAriaSelected();
              });

      $carousel.trigger('select.flickity');

      var resizeTimeout;
      $(window).off('resize.productReviewsCarousel').on('resize.productReviewsCarousel', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
          if ($carousel.hasClass('flickity-enabled')) {
            $carousel.flickity('resize');
          }
        }, 300);
      });
    });
  },

  unload: function($target) {
    var $carousel = $target.find('.js-product-reviews-carousel');
    if ($carousel.hasClass('flickity-enabled')) {
      $carousel.flickity('destroy');
    }
    $(window).off('resize.productReviewsCarousel');
  }
};

$(document).ready(function() {
  productReviewsCarousel.init();
});

$(document).on('shopify:section:load', function(event) {
  productReviewsCarousel.init();
});

$(document).on('shopify:section:unload', function(event) {
  productReviewsCarousel.unload($(event.target));
});

